import React from 'react';

// ONE MARKETPLACE SETTING'S INPUT, by its DATATYPE — a SELECT from AVAILABLEVALUES ("Label:value" pairs, comma or pipe
// separated; a bare entry is its own value), a PASSWORD that is never autofilled, a NUMBER, or text. Shared by the
// credential add form (CredentialModal) and a pipeline source's Config (ImplementationBoard), so a setting is drawn
// the same way wherever its value is asked for.
//
// `def` takes either the marketplacesettings column names (DATATYPE, AVAILABLEVALUES, PLACEHOLDER, SETTINGNAME) or
// their camelCase forms (dataType, availableValues, placeholder, name).
export const settingOptions = (availableValues) => String(availableValues || '')
    .split(/[,|]/)
    .map(v => {
        const [lbl, val] = v.trim().split(':');
        return { label: (lbl || '').trim(), value: (val ?? lbl ?? '').trim() };
    })
    .filter(o => o.label);

export default function MarketplaceSettingField({ def, value, onChange, className = 'ppw-input', id, disabled, placeholder }) {
    const dataType = String(def.DATATYPE || def.dataType || '').toUpperCase();
    const name = def.SETTINGNAME || def.name;
    const hint = placeholder !== undefined ? placeholder : (def.PLACEHOLDER || def.placeholder || name);
    if (dataType === 'SELECT') {
        return (
            <select id={id} className={className} value={value || ''} disabled={disabled} onChange={e => onChange(e.target.value)}>
                <option value="">— Select —</option>
                {settingOptions(def.AVAILABLEVALUES || def.availableValues)
                    .map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
        );
    }
    const isPassword = dataType === 'PASSWORD';
    return (
        <input
            id={id}
            className={className}
            type={isPassword ? 'password' : dataType === 'NUMBER' ? 'number' : 'text'}
            autoComplete={isPassword ? 'new-password' : 'off'}
            value={value || ''}
            disabled={disabled}
            onChange={e => onChange(e.target.value)}
            placeholder={hint}
        />
    );
}
